import { HospitalMarkerIcon } from './HospitalMarkerIcon';

/**
 * author: Austin Andrews
 * id FA30BC13-BE77-44F6-BEB1-942749E019A7
 * name hospital-marker
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hospital-marker.svg
 * tags
 * - Medical / Hospital 
 * - Navigation 
 */
export const HospitalLocationIcon = HospitalMarkerIcon;
export default HospitalLocationIcon